/*
    Developer Name :  RAJA
    Developed Date :  03-12-2021
    Page Name      :  Item Mfr Mst Interface
    Created        :  03-12-2021
    Last Edited By : 
    Edited Date    : 
    Last Edited    : 
*/

import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';

export interface ItemMfrParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface ItemMfr {
  id?:number;
  code:string;
  name:string;
  createdBy:number;
  createdDate:Date
  updatedBy:number;
  updatedDate:Date
  tenantId:any;
  createdIP:string;
  updatedIP:string;
    
  parameters?: ItemMfrParameter[];
  links?: any;
}

export abstract class ItemMfrData {
  abstract list(url: string): Observable<ItemMfr[]>;
  abstract create(url: string,data: ItemMfr): Observable<any>;
  abstract update(url: string,data: ItemMfr): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract postData(url: string, data: any[]): Observable<any>;
}